import styled, { css } from 'styled-components';
import { media } from '@deerplusofficial/pos-helper';

export default styled.div`
  flex-grow: 1;
  overflow: auto;
  ${media(
    'tablet',
    css`
      display: flex;
      flex-grow: 0;
      margin-bottom: 40px;
    `
  )};
`;



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/TabContent.js